import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { BookOpen, Download, Eye, FileText } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BookDetailsDialog = ({ book, onClose }) => {
  const navigate = useNavigate();

  if (!book) return null;

  return (
    <Dialog open={!!book} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent data-testid="book-details-dialog" className="max-w-2xl p-0 overflow-hidden rounded-2xl border-0">
        <div className="flex flex-col sm:flex-row">
          <div className="sm:w-2/5 bg-gradient-to-br from-amber-100 to-orange-50 flex items-center justify-center p-6">
            <img
              src={`${API_URL}/library/books/${book.id}/cover`}
              alt={book.title}
              className="w-40 sm:w-full max-w-[220px] rounded-lg shadow-xl"
            />
          </div>
          <div className="sm:w-3/5 p-6 flex flex-col">
            <DialogTitle className="library-font text-xl font-bold text-stone-800 leading-snug pr-6">
              {book.title}
            </DialogTitle>
            <p className="text-sm text-stone-500 mt-1">{book.author}</p>

            <div className="flex flex-wrap gap-2 mt-4">
              <Badge className="bg-[#00966E] hover:bg-[#00966E] text-white">{book.category}</Badge>
              <Badge variant="outline" className="border-amber-400 text-amber-700">
                Възраст {book.age}+
              </Badge>
            </div>

            <p className="text-sm text-stone-600 mt-4 leading-relaxed flex-1">
              {book.description}
            </p>

            <div className="flex items-center gap-4 mt-4 text-xs text-stone-400">
              <span className="inline-flex items-center gap-1">
                <FileText className="h-3.5 w-3.5" /> {book.pages} страници
              </span>
              <span className="inline-flex items-center gap-1">
                <Eye className="h-3.5 w-3.5" /> Прочетена {book.read_count} пъти
              </span>
              <span>{book.size_mb} MB</span>
            </div>

            <div className="flex gap-3 mt-5">
              <Button
                data-testid="read-book-btn"
                onClick={() => navigate(`/library/read/${book.id}`)}
                className="flex-1 h-12 bg-[#00966E] hover:bg-[#007a59] text-white rounded-full font-semibold"
              >
                <BookOpen className="mr-2 h-5 w-5" /> Чети онлайн
              </Button>
              <Button
                data-testid="download-book-btn"
                variant="outline"
                className="h-12 rounded-full border-stone-300 hover:bg-stone-100"
                onClick={() => window.open(`${API_URL}/library/books/${book.id}/download`, '_blank')}
              >
                <Download className="mr-2 h-5 w-5" /> Свали
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
